import { Link } from "react-router-dom";
import { logoTerangUrl } from "../lib/media";

// Footer HP = desain 30/10/2026 (INSTRUKSI PR tampilan HP + FAQ + Kebijakan Privasi, butir A; mengganti papan B1d): logo terang di tengah,
// satu baris tautan (Hubungi Kami → email, FAQ, Syarat dan Ketentuan, Kebijakan Privasi), lalu "{jam} · {hak cipta}". Tanpa WhatsApp dan tanpa
// kotak keunggulan. Jam = isian Kontak di Konten Beranda (kosong → hanya hak cipta). Footer komputer (3 kolom V5) tidak berubah.
export function FooterHp({ konten, settings, jarakAtas = 10 }) {
  const namaToko = settings?.nama_toko || "Hoonstore";
  const tahun = new Date().getFullYear();
  const copyright = (konten?.footer_copyright || "").trim() || `© ${tahun} ${namaToko}`;
  const jam = (konten?.kontak_jam || "").trim();

  return (
    <footer className="hp-footer" style={{ marginTop: jarakAtas }} data-testid="hp-footer">
      <Link to="/" aria-label={namaToko} className="hp-footer__logo-tautan">
        <img src={logoTerangUrl(settings?.logo_terang_url)} alt={namaToko} width="600" height="80" loading="lazy" decoding="async" className="hp-footer__logo" />
      </Link>
      <nav className="hp-footer__tautan" aria-label="Informasi">
        <a href="mailto:halo@hoonstore.com" data-testid="hp-footer-hubungi">Hubungi Kami</a>
        <Link to="/faq" data-testid="hp-footer-faq">FAQ</Link>
        <Link to="/syarat-ketentuan" data-testid="hp-footer-syarat">Syarat dan Ketentuan</Link>
        <Link to="/kebijakan-privasi" data-testid="hp-footer-privasi">Kebijakan Privasi</Link>
      </nav>
      <p className="hp-footer__bawah" data-testid="hp-footer-copyright">{jam ? `${jam} · ${copyright}` : copyright}</p>
    </footer>
  );
}
